import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Layout } from './components/Layout';
import { PasswordGenerator } from './pages/PasswordGenerator';
import { WordCounter } from './pages/WordCounter';
import { FakeNameGenerator } from './pages/FakeNameGenerator';

function App() {
  return (
    <>
      <Helmet>
        <title>DigiVault.club | Online Security Tools</title>
        <meta name="description" content="Free online security and text tools. Generate strong passwords, count words, calculate hashes, and more." />
        <meta name="keywords" content="password generator, word counter, hash calculator, online tools, security tools" />
      </Helmet>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/password-generator" replace />} />
            <Route path="password-generator" element={<PasswordGenerator />} />
            <Route path="word-counter" element={<WordCounter />} />
            <Route path="fake-name-generator" element={<FakeNameGenerator />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;